import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { getHeaderCellStyles } from '../../../reports/utils/getHeaderCellStyles'

export const HeaderCell = styled.th`
  ${getHeaderCellStyles()}
`

export const SkeletonCell = styled.td`
  padding: ${Spacing.S16} ${Spacing.S32} ${Spacing.S16} ${Spacing.S40};
  border-bottom: 1px solid ${Color.Grey150};
  text-align: right;
`

export const SkeletonHeaderCell = styled.td`
  padding: ${Spacing.S32} ${Spacing.S32} ${Spacing.S24} ${Spacing.S40};
`
